import { render, staticRenderFns } from "./ControlBreakpointChooser.vue?vue&type=template&id=fa12a8f2&"
import script from "./ControlBreakpointChooser.vue?vue&type=script&lang=ts&"
export * from "./ControlBreakpointChooser.vue?vue&type=script&lang=ts&"
import style0 from "./ControlBreakpointChooser.vue?vue&type=style&index=0&id=fa12a8f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports